import * as React from "react";
import { forwardRef } from "react";
const SvgIcCustomize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 3, width: 16, height: 7, rx: 2, stroke: "#131F60", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 4, y: 16, width: 5, height: 5, rx: 1, stroke: "#131F60", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 12, y: 13, width: 8, height: 8, rx: 2, stroke: "#131F60", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgIcCustomize);
export default ForwardRef;
